// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import RootRef from "@material-ui/core/RootRef";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { getUserStatus } from "../../actions/companyActions";
import { updateAdminCompanyUser } from "../../../admin/actions/companyAdminActions";
import { updateAdminFacebaseUser } from "../../../admin/actions/facebaseAdminActions";
import { deleteUser } from "../../../admin/actions/userAdminActions";
import { elementInViewport } from "../../../global/functions/ViewPort";
import { hasPrincipal } from "../../../global/containers/UserAuth";
import UserItem from "../../components/users/UserItem";

type UserItemReduxPropsType = {
  user: { [key: string]: * },
  isAdmin?: boolean,
  companyId?: string,
  facebaseId?: string,
  openSnackbar?: Function,
  currentUser: { [key: string]: * },
  userList: Array<*>,
  actions: {
    getUserStatus: Function,
    updateAdminCompanyUser: Function,
    updateAdminFacebaseUser: Function,
    deleteUser: Function
  }
};

type UserItemReduxStatesType = {
  display: boolean
};

class UserItemRedux extends Component<
  UserItemReduxPropsType,
  UserItemReduxStatesType
> {
  constructor(props: UserItemReduxPropsType) {
    super(props);
    this.state = {
      display: false
    };
    this.panelRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("scroll", this.scrollListener);
    this.scrollListener();
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.scrollListener);
  }

  componentDidUpdate(
    prevProps: UserItemPropsType,
    prevState: UserItemStatesType
  ) {
    if (
      prevState.display === false &&
      this.state.display === true &&
      !this.hasGotUserEmail()
    ) {
      if (this.props.isAdmin) {
        let userList = this.props.userList;
        let user = { ...this.props.user };

        if (this.props.facebaseId) {
          //admin facebases
          user.cognitoUuid = user.uuid;
          user.fullName =
            (user.first_name ? user.first_name : "") +
            " " +
            (user.last_name ? user.last_name : "");
        }

        let reduxUser = { ...userList[user.cognitoUuid] };
        user.user_status = reduxUser.user_status;
        user.email = reduxUser.email;

        if (this.props.facebaseId) {
          this.props.actions.updateAdminFacebaseUser(
            this.props.facebaseId,
            user
          );
        } else {
          this.props.actions.updateAdminCompanyUser(this.props.companyId, user);
        }
      } else {
        this.props.actions.getUserStatus(
          this.props.user.id,
          this.props.user.cognitoUuid,
          (err: string): * => console.log(err)
        );
      }
    }
  }

  hasGotUserEmail = (): * => {
    const user = this.props.user;
    if (user.email && user.user_status) {
      return true;
    } else {
      return false;
    }
  };

  scrollListener = (): * => {
    const elm = this.panelRef.current;
    if (elementInViewport(elm)) {
      this.setState({ display: true });
    }
  };

  deleteUser = (
    userCognitoId: string,
    doneCall: Function,
    failCall: Function
  ): * => {
    this.props.actions.deleteUser(
      userCognitoId,
      this.props.isAdmin
        ? this.props.facebaseId
          ? "adminFacebase"
          : "adminCompany"
        : "company",
      this.props.isAdmin
        ? this.props.facebaseId
          ? this.props.facebaseId
          : this.props.companyId
        : null,
      doneCall,
      failCall
    );
  };

  render(): * {
    const isImagusAdmin = hasPrincipal(
      "imagus_admin",
      this.props.currentUser.groups
    );

    return (
      <RootRef rootRef={this.panelRef}>
        <UserItem
          user={this.props.user}
          isImagusAdmin={isImagusAdmin}
          deleteUser={this.deleteUser}
          openSnackbar={this.props.openSnackbar}
        />
      </RootRef>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  currentUser: state.v3account.user,
  userList: state.v3admin.user.users
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      getUserStatus,
      updateAdminCompanyUser,
      updateAdminFacebaseUser,
      deleteUser
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserItemRedux);
